import { createVueApp } from "@saflib/vue";
import { setClientName } from "@saflib/links";
import App from "./AuthApp.vue";
import "vuetify/styles";
import {
  vuetifyConfig,
  sentryCallback,
  initClientObservability,
  powerUpMfaRequiredHref,
} from "@vendata/power-up-clients-common";
import { createPowerUpAuthRouter } from "./router";
import { authAppStrings } from "./strings";

export const main = () => {
  setClientName("auth");
  initClientObservability();
  createVueApp(App, {
    router: createPowerUpAuthRouter(),
    vuetifyConfig,
    i18nMessages: {
      ...authAppStrings,
    },
    callback: sentryCallback,
    mfaRequiredHref: powerUpMfaRequiredHref(),
  });
};
